import {setConfig, getConfig, removeConfig} from '@/utils/auth'
import {getThemeConfig} from '@/api/public'

const state = {
	config: null
}
const mutations = {
	SET_CONFIG: (state, config) => {
		state.config = config
	}
}

const actions = {
    getThemeCfg({commit, state}) {
        return new Promise((resolve, reject) => {
            getThemeConfig().then(res => {
                if(res.code == 1) {
                    const {data} = res
                    commit("SET_CONFIG", data);
                    setConfig(data);
                    resolve(data);
                } else {
                    reject()
                }
            }).catch(() => {
                reject()
            })
        })
    },
    clearCfg({commit, state}) {
        return new Promise((resolve, reject) => {
            commit("SET_CONFIG", null);
            removeConfig()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};